// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","colorGreenUltraLight":"#DBF3CC","colorRedUltraLight":"#ffd7da","colorYellowUltraLight":"#ffecbd","paragraph":"_1RZCDyBp45CoeE_DKlNw-E _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","alert":"-mQwG_MoWQwpNGtkA27E4 _1RZCDyBp45CoeE_DKlNw-E _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","success":"_1HA0C7ruY_VJ6p1Fwv1ryi","warning":"_3Dg-AiMBZBrRKkXQ1YELJ_","error":"_2UNsUbueAfPLxuvkufnhfm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/alert/alert.css
// module id = 1061
// module chunks = 0